'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderOverviewSearchComponent = exports.orderOverviewSearchComponent = {
    template: require('./order-overview-search.html'),
    bindings: {
        searchValue: '=',
        search: '&',
        sellers: '<'
    },
    controllerAs: 'vm',
    controller: function contractsOverviewController() {
        'ngInject';

        var vm = this;
        vm.onSearch = onSearch;
        vm.$onInit = init;

        function init() {
            vm.selectedSeller = vm.sellers[0];
        }

        function onSearch() {
            var data = {
                searchValue: vm.searchValue,
                selectedSeller: vm.selectedSeller
            };
            vm.search({ $event: data });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/account/components/order-overview-search.js
// module id = 844
// module chunks = 0